const loader = require('./dist');

module.exports = loader;
